import React from 'react';

import { Button } from '../../elements';
import { Layout } from '../../components';
import { BUILDING_PAGE } from '../../navigation/routes';
import styles from './StartPage.module.scss';



const StartPage = () => {
	return (
		<Layout showHeader={false} autoScroll={false}>
			<div className={styles.buttonWrapper}>
				<Button to={BUILDING_PAGE} title='Konfigurator starten' variant='link' />
			</div>
		</Layout>
	);
};

export default StartPage;
